import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';
import { useSelectedCanvasNodes } from '../useSelectedCanvasNodes';

export function useRenameShortcut() {
  const selectedNodes = useSelectedCanvasNodes();

  const canRename =
    selectedNodes.length === 1 && (selectedNodes[0].type === 'image' || selectedNodes[0].type === 'video');

  useHotkeys(
    'meta+r,ctrl+r',
    () => {
      if (canRename) {
        useEditCanvasStore.getState().setRenamingNodeId(selectedNodes[0].id);
      }
    },
    { enabled: canRename, preventDefault: true },
    [canRename, selectedNodes],
  );
}
